import CancelablePromise from 'mn-utils/CancelablePromise';
import {TCurrency, TFilter, TList, TResponse} from '@/types';

import {get, post} from '../../http';

import {TListItem, TCreateParams, TToggleParams} from './types';
import {getCryptoAccountsList} from './mock';

export function apiV2CryptoWalletsList(params: TFilter<TListItem, {app_id: String, amount_currency: TCurrency, is_enabled: Boolean}>): Promise<TList<TListItem>> {
  const url = `/f2c/v1/console/apps/${params.app_id}/crypto-wallets`;
  params = params || {};
  params.offset = params.offset || 0;
  params.limit = params.limit || 50;

  if (process.env.MOCK) {
    const response = {
      list: getCryptoAccountsList(params.limit),
      count: params.limit * 10,
    };
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }

  return get(url, params).then((list = []) => {
    return ({list, count: list.length})
  });
}

export function apiV2CryptoWalletCreate(params: TCreateParams): Promise<TResponse> {
  const {app_id: appID, ...props} = params;
  const url = `/f2c/v1/console/apps/${appID}/crypto-wallets`;
  if (process.env.MOCK) {
    const response = {status: 'SUCCESS'};
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }

  return post(url, props);
}

export function apiV2CryptoWalletToggle(params: TToggleParams): Promise<TResponse> {
  const {wallet_id: walletID, ...props} = params;
  const url = `/f2c/v1/console/crypto-wallet/${walletID}`;

  if (process.env.MOCK) {
    const response = {status: 'SUCCESS'};
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }

  return post(url, props);
}
